module.exports = __webpack_public_path__ + "img/MNZ.a5e2a11a.svg";